import { cn } from '@utima/ui';
import { CircleCheck, CircleDashed, CircleX } from 'lucide-react';
import { memo } from 'react';

import type { PasswordValidationError } from './passwordValidate';

type ValidationIconProps = {
  className?: string;
  targetValidationError: PasswordValidationError;
  validationErrors?: PasswordValidationError[];
};

export const ValidationIcon = memo(function ({
  className,
  validationErrors,
  targetValidationError,
}: ValidationIconProps) {
  const iconClassName = cn('size-4 shrink-0', className);

  if (!validationErrors) {
    return <CircleDashed className={cn(iconClassName, 'text-foreground')} />;
  }

  if (validationErrors.includes(targetValidationError)) {
    return <CircleX className={cn(iconClassName, 'text-danger')} />;
  }

  return <CircleCheck className={cn(iconClassName, 'text-success')} />;
});
